import { Button } from "../../components/Button";
import { MarketStrip } from "./MarketStrip";

export function MarketSectionsList({
  groupedSections,
  loadingDetails,
  reservingItemId,
  onOpenItem,
  onReserve,
}) {
  return (
    <div className="marketSections">
      {groupedSections.length === 0 ? <p className="muted">Пока товаров нет.</p> : null}
      {groupedSections.map((section) => (
        <section key={section.id} className="marketSection">
          <div className="marketSection__head">
            <h3>{section.title}</h3>
          </div>
          <p className="marketSection__hint">Свайп влево/вправо</p>
          <div className="marketStripViewport">
            <MarketStrip>
              {section.items.map((item) => (
                <div
                  key={item.id}
                  className="marketLot"
                  onClick={() => {
                    if (loadingDetails) return;
                    onOpenItem(item.id);
                  }}
                  onKeyDown={(event) => {
                    if (loadingDetails) return;
                    if (event.key === "Enter" || event.key === " ") {
                      event.preventDefault();
                      onOpenItem(item.id);
                    }
                  }}
                  role="button"
                  tabIndex={0}
                  aria-disabled={loadingDetails}
                >
                  <p className="marketLot__title">{item.title}</p>
                  <div className="marketLot__image">
                    {item.image_url ? <img src={item.image_url} alt={item.title} /> : null}
                  </div>
                  <p className="marketLot__stock">Осталось: {Number(item.stock_quantity || 0)} шт.</p>
                  <div className="marketLot__prices">
                    <div className="marketLot__priceLine marketLot__priceLine--main">
                      <span>{Number(item.price || 0).toFixed(2)} руб.</span>
                      <Button
                        type="button"
                        disabled={Number(item.stock_quantity || 0) <= 0 || !!reservingItemId}
                        onClick={(event) => {
                          event.stopPropagation();
                          onReserve(item.id, "rub");
                        }}
                        className={reservingItemId === item.id ? "button--busy" : ""}
                      >
                        {reservingItemId === item.id ? "Забронирование..." : "Купить"}
                      </Button>
                    </div>
                    <div className="marketLot__priceLine">
                      <span>{Number(item.price_bonus || 0)} баллов</span>
                      <Button
                        type="button"
                        disabled={Number(item.stock_quantity || 0) <= 0 || !!reservingItemId}
                        onClick={(event) => {
                          event.stopPropagation();
                          onReserve(item.id, "bonus");
                        }}
                        className={reservingItemId === item.id ? "button--busy" : ""}
                      >
                        {reservingItemId === item.id ? "Забронирование..." : "Купить"}
                      </Button>
                    </div>
                  </div>
                </div>
              ))}
            </MarketStrip>
          </div>
        </section>
      ))}
    </div>
  );
}
